import { CancelOutlined } from "@mui/icons-material";
import { Alert, FormControl, FormHelperText } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import MemberSearchDataHost from "utils/MemberSearchDataHostModel";
import { devLog } from "utils/devLog";

/**
 * A component for rendering a member search input field
 *  *@param {Object} props - dataHost
 */
function SelectMemberSearchType(props) {
  const [dataHost, setDataHost] = useState(props.dataHost);
  const [searchTypes, setSearchTypes] = useState(props.dataHost.searchTypes || []);
  const [selectedSearchType, setSelectedSearchType] = useState(
    props.dataHost.selected || props.dataHost.searchTypes[0],
  );
  const [render, rerender] = useState(true);

  useEffect(() => {
    setDataHost(props.dataHost);
    setSearchTypes(props.dataHost.searchTypes);
    setSelectedSearchType(props.dataHost.selected || props.dataHost.searchTypes[0]);
  }, [props.dataHost]);

  const onSearchTypeAdded = (newType) => {
    setSearchTypes([...dataHost.searchTypes]);
  };

  const onSearchTypeSelected = (newType) => {
    setSelectedSearchType(newType);
    rerender(!render);
  };

  const onUserClick = (st) => {
    st.setSelected(st);
    setSelectedSearchType(st);
  };

  useEffect(() => {
    dataHost.addEventListener("onSearchTypeAdded", onSearchTypeAdded);
    dataHost.addEventListener("onSearchTypeSelected", onSearchTypeSelected);
    return () => {
      dataHost.removeEventListener("onSearchTypeAdded", onSearchTypeAdded);
      dataHost.removeEventListener("onSearchTypeSelected", onSearchTypeSelected);
    };
  }, [dataHost]);

  return (
    <>
      <Dropdown
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
          {selectedSearchType.label}
        </Dropdown.Toggle>
        <Dropdown.Menu variant="dark">
          {searchTypes.map((searchType, index) => {
            return (
              <Dropdown.Item
                key={searchType.key}
                active={searchType.selected}
                onClick={(e) => {
                  devLog(e);
                  devLog("change search type to: ", searchType);
                  onUserClick(searchType);
                }}
              >
                {searchType.label}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
      {selectedSearchType && <MemberSearchInputs searchTypeHost={selectedSearchType} />}
    </>
  );
}

function MemberSearchInputs(props) {
  const [searchTypeHost, setSearchTypeHost] = useState(props.searchTypeHost);
  const [inputs, setInputs] = useState(props.searchTypeHost.inputs);
  const [render, rerender] = useState(true);

  useEffect(() => {
    setSearchTypeHost(props.searchTypeHost);
    setInputs(props.searchTypeHost.inputs);
  }, [props.searchTypeHost]);

  const onSearchTypeSelected = (searchType) => {
    setSearchTypeHost(searchType);
    setInputs(searchType.inputs);
    rerender(!render);
  };

  useEffect(() => {
    searchTypeHost.dataHost.addEventListener("onSearchTypeSelected", onSearchTypeSelected);
    return () => {
      searchTypeHost.dataHost.removeEventListener("onSearchTypeSelected", onSearchTypeSelected);
    };
  }, [searchTypeHost]);

  return (
    <>
      {inputs.map((inputDataHost) => {
        devLog(inputDataHost.label);
        return <MemberSearchInput key={inputDataHost.key} inputDataHost={inputDataHost} />;
      })}
    </>
  );
}

function MemberSearchInput(props) {
  const [inputDataHost, setInputDataHost] = useState(props.inputDataHost);
  const [label, setLabel] = useState(props.inputDataHost.label);
  const [key, setKey] = useState(props.inputDataHost.key);
  const [type, setType] = useState(props.inputDataHost.type);
  const [value, setValue] = useState(props.inputDataHost.value || "");
  const [error, setError] = useState(props.inputDataHost.error);
  const [render, serRender] = useState(false);
  const [validationErrorMsg, setValidationErrorMsg] = useState(props.inputDataHost.validationErrorMessage);

  useEffect(() => {
    devLog("MemberSearchInput: props.inputDataHost changed");
    setInputDataHost(props.inputDataHost);
    setLabel(props.inputDataHost.label);
    setKey(props.inputDataHost.key);
    setType(props.inputDataHost.type);
    setValue(props.inputDataHost.value || "");
    setError(props.inputDataHost.error);
    setValidationErrorMsg(props.inputDataHost.validationErrorMessage);
  }, [props.inputDataHost]);

  const onValueChange = (val) => {
    devLog(`onValueChange ${label} val: `, val);
    setValue(val);
    serRender(!render);
  };

  const onValidateStatusChange = (isError) => {
    setError(isError);
  };

  useEffect(() => {
    if (props.inputDataHost) {
      inputDataHost.addEventListener("onValueChange", onValueChange);
      inputDataHost.addEventListener("onValidateStatusChange", onValidateStatusChange);
    }
    return () => {
      if (props.inputDataHost) {
        inputDataHost.removeEventListener("onValueChange", onValueChange);
        inputDataHost.removeEventListener("onValidateStatusChange", onValidateStatusChange);
      }
    };
  }, [props.inputDataHost]);

  // const memberNumberLimit = (e) => {
  //   if (key === "memberNumber" && e.target.value.length > 6) {
  //     e.target.value = e.target.value.slice(0, -1);
  //     devLog("member number Length error");
  //   }
  //   return e.target.value;
  // };

  const helpTextStyle = {
    style: {
      fontSize: "13px",
      color: "red",
      marginLeft: 0,
    },
  };

  return (
    <>
      <FormControl
        error={error}
        style={{
          width: "100%",
          backgroundColor: "white",
          padding: 10,
          marginTop: 10,
        }}
      >
        <TextField
          id="outlined-basic-${inputDataHost.key}"
          label={label}
          variant="outlined"
          size="small"
          fullWidth={true}
          value={value}
          type={type}
          error={error}
          onChange={(e) => {
            // const processedValue = memberNumberLimit(e);
            devLog("target value change: ", e.target.value);
            inputDataHost.setValue(e.target.value);
          }}
          onClick={(e) => {
            setError(false);
          }}
          helperText={error ? `❗${validationErrorMsg}` : ""}
          FormHelperTextProps={helpTextStyle}
        />
      </FormControl>
    </>
  );
}

export default function CREMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [selectedSearchType, setSelectedSearchType] = useState(
    props.currState.MemberLookup.searchType || "PHONE_NUMBER",
  );

  /**
   * @type {ReturnType<typeof useState<MemberSearchDataHost>>}
   */
  const [memberSearchData, setMemberSearchData] = useState(props.memberSearchService);

  useEffect(() => {
    devLog("memberSearchData.setWebAppContext props.currState: ", props.currState);
    // const host = new MemberSearchDataHost(searchTypesData);
    memberSearchData.setWebAppContext(props.context);
    memberSearchData.init();
    const st = memberSearchData.getSearchTypeBykey(selectedSearchType);
    if (st) {
      st.setSelected(true);
    }
    // setMemberSearchData(host);
    devLog("SearchTypeDataHost: ", memberSearchData);
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = memberSearchData.getData();
    const isValidated = memberSearchData.validate();
    devLog("data", data);
    devLog("isValidated", isValidated);
    if (!isValidated) {
      devLog("onSubmit details are invalid");
      return;
    }

    if (typeof props.onFormSubmit === "function" && isValidated) {
      if (data) {
        props.onFormSubmit(data);
      }
    }
  };

  const cancelOutline = { width: 20, color: "black", marginRight: 4 };
  const cancelBtn = {
    background: "#f4f4f4",
    color: "black",
    paddingLeft: 14,
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          {memberSearchData && <SelectMemberSearchType dataHost={memberSearchData} />}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={cancelBtn}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={cancelOutline} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
